// extracted by mini-css-extract-plugin
module.exports = {"igv-btn":"IgvLoadBAM_igv-btn__2rqW_"};